module.exports = __webpack_public_path__ + "img/2.d19b6f82.jpg";